export default "__VITE_ASSET__MF6hWWK$__"